import styled from "styled-components";
import WhatWeDoServiceHeader from "../WhatWeDoHeader";
import CustomSplitText from "@/mono/components/CustomSplitText";
import BorderedIcon from "@/components/BorderedIcon";
import ColumnRow, { columnRowTypeNames } from "../../contentSections/ColumnRow";
import { TransitionLink } from "mono/components/TransitionLink";

export default function WhatWeDoServiceWebdesign() {
  return (
    <Wrapper>
      <WhatWeDoServiceHeader
        fullServiceName="Webdesign"
        service="Web-"
        serviceBottom="design"
      >
        <div>
          <CustomSplitText tag="p">
            Een professionele website is meer dan een mooi plaatje – het is een
            krachtig middel om klanten te overtuigen. Bij Nine draait webdesign
            om strategie, gebruiksgemak en een uitstraling die perfect past bij
            jouw merk.
          </CustomSplitText>
          <CustomSplitText tag="p">
            Een goed ontwerp vergroot betrokkenheid, verhoogt conversies en
            versterkt je merk. Met de juiste structuur en visuele impact wordt
            jouw site een basis voor groei en online succes.
          </CustomSplitText>
        </div>
        <TransitionLink href="/service/webdesign">
          <BorderedIcon text={"More about <strong>webdesign</strong>"} />
        </TransitionLink>
      </WhatWeDoServiceHeader>
      <ColumnRow
        data={{
          columns: [
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/webdesign1.jpeg",
              },
              width: 70,
            },
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/webdesign2.jpeg",
              },
              width: 30,
            },
          ],
        }}
      />
      <ColumnRow
        data={{
          columns: [
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/webdesign3.mp4",
              },
              width: 100,
            },
          ],
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .icon-container {
    margin-top: 150rem;
  }
  margin-bottom: 150rem;
`;
